module.exports = __webpack_public_path__ + "img/1.1.b2a6b4a0.svg";